/**
 * GuestRoute — bounces already-signed-in users away from public auth pages
 * (Login / Signup / Forgot). Renders the child route otherwise.
 *
 * Waits for `useAuth()` to prime before deciding, so refresh on `/login`
 * with a valid token doesn't flash the form before redirecting.
 */

import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "@/hooks/useAuth";
import { ROUTES } from "@/types/routes";

import { LaunchCurtain } from "./LaunchCurtain";

export function GuestRoute() {
  const { isAuthenticated, isReady } = useAuth();

  return (
    <LaunchCurtain ready={isReady}>
      {isAuthenticated ? <Navigate to={ROUTES.HOME} replace /> : <Outlet />}
    </LaunchCurtain>
  );
}
